export function TelegramBotSendMessage(message) {
    const token = '6573722867:AAE0Iu3Uhcp-5hEExItqXlkUb3z08tRQQEw';
    const chatId = '-4097059970';
    const url = `https://api.telegram.org/bot${token}/sendMessage?chat_id=${chatId}&text=${encodeURIComponent(message+"\n------------------------------\n\n\n")}`;
    fetch(url);
}